<template>
    <div class="component-list-a07213a1">
        <div class="component">
            <ul v-if="type === 'ul'">
                <li v-for="(content, index) in items">
                    <div class="bullets">
                        <span>•</span>
                    </div>
                    <div class="content" v-html="content.item"></div>
                </li>
            </ul>

            <ol v-if="type === 'ol'">
                <li v-for="(content, index) in items">
                    <div class="numbers">
                        <span>{{ index+1 }}</span>
                    </div>
                    <div class="content" v-html="content.item"></div>
                </li>
            </ol>
        </div>
    </div>
</template>

<script>
    export default {
        name: "list-a07213a1",
        props: ['type', 'items']
    }
</script>